import { common } from '../common.js';
import type { IProgram } from '../types.js';

/** Sponsoring a dependent child only (no spouse or partner on the application). */
export const DEPENDENT_CHILD: IProgram = {
  id: 'dependent-child',
  name: 'Dependent child sponsorship',
  short: 'Child sponsorship',
  family: 'family',
  status: 'active',
  version: '2026-10-04',
  review: 'pending',
  sources: [
    { title: 'IRCC Guide 5289: Sponsor your spouse, common-law partner, conjugal partner or dependent child (complete guide)', url: 'https://www.canada.ca/en/immigration-refugees-citizenship/services/application/application-forms-guides/guide-5289-sponsor-your-spouse-common-law-partner-conjugal-partner-dependent-child-complete-guide.html', retrieved: '2026-10-04' }
  ],
  questions: [
    { id: 'childWithoutBothParents', text: 'Will a child travel to Canada without both parents or guardians?', kind: 'yesno' },
    { id: 'childHasChildren', text: 'Does the child have dependent children of their own?', kind: 'yesno' }
  ],
  roles: [
    { id: 'sponsor', label: 'Sponsor (parent)', min: 1, max: 1 },
    { id: 'principal', label: 'Child being sponsored', min: 1, max: 1 },
    { id: 'dependant', label: 'Child\'s own dependent child', min: 0, max: 10 }
  ],
  sections: ['Forms', 'Identity and civil documents', 'Photos and police certificates', 'Sponsor', 'Fees'],
  items: [
    { id: 'checklist', label: 'IRCC document checklist for the country where the child lives, filled in', section: 'Forms', forRoles: 'application', source: 0 },
    { id: 'imm1344', label: 'Application to Sponsor, Sponsorship Agreement and Undertaking', form: 'IMM 1344', section: 'Forms', forRoles: 'application', source: 0 },
    { id: 'imm5481', label: 'Sponsorship Evaluation', form: 'IMM 5481', section: 'Forms', forRoles: 'application', source: 0 },
    { id: 'imm1283', label: 'Financial Evaluation', form: 'IMM 1283', section: 'Forms', forRoles: 'application', when: { q: 'childHasChildren', is: true }, source: 0, hint: 'The guide asks for it when the child has dependent children of their own; check the checklist for this file.' },
    { id: 'imm0008', label: 'Generic Application Form for Canada (online)', form: 'IMM 0008', section: 'Forms', forRoles: ['principal'], source: 0, hint: 'A parent or legal guardian signs for a child under 18.' },
    { id: 'imm5669', label: 'Schedule A, Background/Declaration (online)', form: 'IMM 5669', section: 'Forms', forRoles: ['principal', 'dependant'], minAge: 18, source: 0 },
    { id: 'imm5406', label: 'Additional Family Information (online)', form: 'IMM 5406', section: 'Forms', forRoles: ['principal', 'dependant'], minAge: 18, source: 0 },
    { id: 'imm5604', label: 'Separation Declaration for Minors Travelling to Canada, with the other parent\'s photo ID', form: 'IMM 5604', section: 'Forms', forRoles: ['principal', 'dependant'], when: { q: 'childWithoutBothParents', is: true }, source: 0 },
    common.representative(0),
    common.passport(0, ['principal', 'dependant']),
    { id: 'birth', label: 'Birth certificate naming the parents', section: 'Identity and civil documents', forRoles: ['principal', 'dependant'], source: 0, translationIfNotEnFr: true },
    { id: 'custody', label: 'Custody documents, if a parent isn\'t the sponsor or doesn\'t travel', section: 'Identity and civil documents', forRoles: 'application', source: 0, translationIfNotEnFr: true },
    common.photos(0, ['principal', 'dependant']),
    common.police(0, ['principal', 'dependant']),
    { id: 'sponsorStatus', label: 'Proof of the sponsor\'s status in Canada (citizenship or permanent residence)', section: 'Sponsor', forRoles: ['sponsor'], source: 0 },
    common.translations(0),
    common.fees(0)
  ],
  deadlines: []
};
